import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconUpload(props: IconProps) {
	return (
		<Icon stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" {...props}>
			<path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
			<path d="M7 9l5 -5l5 5" />
			<path d="M12 4l0 12" />
		</Icon>
	);
}
